import { ref, computed, nextTick } from 'vue'
import { isObject } from '../utils/helpers'

export default function formElementMixin(context) {
  const isFocused = ref(false)

  /**
   * @param {Event} $event
   * @description The on blur handler for the input
   */
  const onBlur = (event) => {
    isFocused.value = false
    context.emit('blur', event)
    context.validation.validate(event)
  }

  /**
   * @param {Event} $event
   * @description The on focus handler for the input
   */
  const onFocus = (event) => {
    isFocused.value = true
    context.emit('focus', event)
  }

  /**
   * @return {Number|String}
   * @description Returns the max length property of the component
   */
  const maxlength = computed(() => {
    return isObject(context) && isObject(context.attrs)
      ? context.attrs.maxlength
      : undefined
  })

  /**
   * @description Focus method that work dynamically depending on the component.
   */
  const focus = () => {
    /* istanbul ignore next */
    if (context.input.value === undefined) return
    nextTick(() => {
      context.input.value.focus()
    })
  }

  return {
    onFocus,
    onBlur,
    isFocused,
    maxlength,
    focus,
  }
}
